import { useState, useEffect, useRef, useCallback } from 'react';
import StudentCard from './StudentCard';
import PokemonSelector from './PokemonSelector'; 
import WholeClassCard from './WholeClassCard';

const StudentGridView = ({ 
    students, loading, onScoreChange, onAvatarUpdate, onWholeClassUpdate, 
    onAddStudent, onDeleteStudent, onEditStudent, onBuyCard, onUseCard,
    isEditMode // YENİ: Ana bileşenden gelen düzenleme modu bilgisi
}) => {
    const [isSelectorOpen, setIsSelectorOpen] = useState(false);
    const [selectedStudentForAvatar, setSelectedStudentForAvatar] = useState(null);
    const [gridStyle, setGridStyle] = useState({});
    const containerRef = useRef(null);

    const calculateLayout = useCallback(() => {
        if (!containerRef.current) return;
        const count = students.length + 2; 
        const width = containerRef.current.clientWidth;
        const height = containerRef.current.clientHeight;
        const gap = 12; 

        let bestCols = 1;
        let bestRows = 1;
        let bestSize = 0;

        for (let cols = 1; cols <= count; cols++) {
            const rows = Math.ceil(count / cols);
            const availableWidth = width - (cols - 1) * gap;
            const availableHeight = height - (rows - 1) * gap;
            const cardW = availableWidth / cols;
            const cardH = availableHeight / rows;
            const size = Math.min(cardW, cardH);
            if (size > bestSize) {
                bestSize = size;
                bestCols = cols;
                bestRows = rows;
            }
        }
        setGridStyle({
            display: 'grid',
            gridTemplateColumns: `repeat(${bestCols}, 1fr)`,
            gridTemplateRows: `repeat(${bestRows}, 1fr)`,
            gap: `${gap}px`,
            width: '100%',
            height: '100%',
            overflowY: 'auto',
            paddingRight: '5px',
            paddingTop: '10px' // Üstten hafif boşluk
        });
    }, [students.length]);

    useEffect(() => {
        calculateLayout();
        const observer = new ResizeObserver(calculateLayout);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, [calculateLayout]);

    const handleAvatarClick = (student) => {
        setSelectedStudentForAvatar(student);
        setIsSelectorOpen(true);
    };

    const handlePokemonSelect = (pokemonId) => {
        if (selectedStudentForAvatar) {
            onAvatarUpdate(selectedStudentForAvatar.id, pokemonId);
        }
    };

    if (loading) return <div style={{display:'flex', justifyContent:'center', marginTop:'20%'}}><div className="ct-loader"></div></div>;
    
    const sortedStudents = [...students].sort((a, b) => a.name.localeCompare(b.name, 'tr'));
    const totalClassScore = students.reduce((acc, student) => acc + student.score, 0);

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: '1', minHeight: '0', position: 'relative' }}>
                <div ref={containerRef} style={{ width: '100%', height: '100%', position: 'absolute', inset: 0 }}>
                    <div style={gridStyle}>
                        
                        <WholeClassCard onWholeClassUpdate={onWholeClassUpdate} totalScore={totalClassScore} />

                        {sortedStudents.map(student => (
                            <StudentCard
                                key={student.id}
                                student={student}
                                isEditMode={isEditMode} // Ana merkezden gelen sinyali kartlara aktar
                                onScoreChange={onScoreChange}
                                onAvatarClick={handleAvatarClick}
                                onDeleteStudent={onDeleteStudent}
                                onEditStudent={onEditStudent}
                                onBuyCard={onBuyCard}
                                onUseCard={onUseCard}
                            />
                        ))}

                        <div 
                            className="ct-student-card"
                            style={{ 
                                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
                                cursor: 'pointer', border: '2px dashed rgba(56, 189, 248, 0.4)', 
                                background: 'rgba(15, 23, 42, 0.5)', backdropFilter: 'blur(5px)',
                                borderRadius: '16px', transition: 'all 0.2s', boxShadow: 'inset 0 0 20px rgba(56,189,248,0.05)',
                                minHeight: '140px'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = 'rgba(15, 23, 42, 0.8)';
                                e.currentTarget.style.borderColor = 'rgba(56, 189, 248, 0.8)';
                                e.currentTarget.style.boxShadow = 'inset 0 0 30px rgba(56,189,248,0.15)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = 'rgba(15, 23, 42, 0.5)';
                                e.currentTarget.style.borderColor = 'rgba(56, 189, 248, 0.4)';
                                e.currentTarget.style.boxShadow = 'inset 0 0 20px rgba(56,189,248,0.05)';
                            }}
                            onClick={() => {
                                const name = window.prompt("Yeni mürettebatın ad ve soyadını girin:");
                                if(name) onAddStudent(name.toUpperCase());
                            }}
                        >
                            <span style={{ fontSize: '3rem', color: '#38bdf8', lineHeight: '1', textShadow: '0 0 10px rgba(56,189,248,0.5)' }}>+</span>
                            <span style={{ color: '#bae6fd', fontWeight: 'bold', marginTop: '8px', letterSpacing: '1px' }}>Mürettebat Ekle</span>
                        </div>

                    </div>
                </div>
            </div>

            <PokemonSelector 
                isOpen={isSelectorOpen} 
                onClose={() => setIsSelectorOpen(false)} 
                onSelect={handlePokemonSelect}
            />
        </div>
    );
};

export default StudentGridView;